module.exports = __webpack_public_path__ + "57085800.svg";